import { useCallback, useEffect, useState } from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { api, money, fmtDate } from "@/lib/api";
import { PageHead } from "@/components/admin/PageHead";
import ClientDetailDialog from "@/components/admin/ClientDetailDialog";

export default function AdminClients() {
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  const [openId, setOpenId] = useState(null);

  const load = useCallback(() => api.get("/admin/clients", { params: { q } }).then(({ data }) => setItems(data)).catch(() => {}), [q]);
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [load]);

  return (
    <div data-testid="admin-clients-page">
      <PageHead title="Clients" subtitle="View balances and positions, or adjust cash manually.">
        <div className="relative w-full sm:w-72">
          <Search className="absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name or email" className="field pl-11" data-testid="admin-clients-search-input" />
        </div>
      </PageHead>
      <div className="panel overflow-x-auto">
        <table className="w-full min-w-[760px] text-left text-sm">
          <thead><tr className="border-b border-line text-slate-500">
            <th className="px-6 py-4 font-medium">Client</th><th className="px-6 py-4 font-medium">Joined</th>
            <th className="px-6 py-4 text-right font-medium">Cash</th><th className="px-6 py-4 text-right font-medium">Holdings</th>
            <th className="px-6 py-4 text-right font-medium">Total</th>
          </tr></thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.id} onClick={() => setOpenId(c.id)} className="cursor-pointer border-b border-line/60 transition-colors last:border-0 hover:bg-white/[0.03]" data-testid={`admin-client-row-${c.id}`}>
                <td className="px-6 py-4"><p className="text-white">{c.name}</p><p className="text-xs text-slate-500">{c.email}</p></td>
                <td className="px-6 py-4 text-slate-400">{fmtDate(c.created_at)}</td>
                <td className="px-6 py-4 text-right font-mono text-emerald-400">{money(c.cash_balance)}</td>
                <td className="px-6 py-4 text-right font-mono">{money(c.holdings_value)} <span className="text-xs text-slate-500">({c.positions})</span></td>
                <td className="px-6 py-4 text-right font-mono text-white">{money(c.total_value)}</td>
              </tr>
            ))}
            {!items.length && <tr><td colSpan={5} className="px-6 py-12 text-center text-slate-500" data-testid="admin-clients-empty">No clients found.</td></tr>}
          </tbody>
        </table>
      </div>
      <ClientDetailDialog clientId={openId} onOpenChange={(o) => !o && setOpenId(null)} onChanged={load} />
    </div>
  );
}
